import React from 'react'
import './Work.css'
import Upwork from '../../img/Upwork.png'
import Fiverr from '../../img/fiverr.png'
import Shopify from '../../img/Shopify.png'
import Amazon from '../../img/amazon.png'
import Facebook from '../../img/Facebook.png'
import { useContext } from "react";
import { themeContext } from '../../Context';
import {motion} from 'framer-motion';

const Portfolio = () => {
    const transition = {duration : 40, type: 'spring'}

    const theme = useContext(themeContext);
    const darkMode = theme.state.darkMode;
  return (
      <div className="w-left">
          <div className="s-left">
              <span style = {{color : darkMode? 'white': ''}}>Projects Completed for</span>
              <span>Businesses & Clients</span>
              <span style = {{color : darkMode? 'white': ''}}>
                  I offer a range of services to help clients bring their digital projects to life.
                  <br />
                  From creating dynamic websites to designing eye-catching 3D models,
                  <br />
                  I bring creativity and technical expertise to every project I work on.
                  <br />
                  I bring creativity and technical expertise to every project I work on.
                  <br />
              </span>
              <button className=" button s-button" onClick={() => window.location = 'mailto:benjamindaviddawson@gmail.com'}>Contact me</button>

              <div className="blur s-blur" style={{ background: "#ABF1FF94" }} ></div>   
          </div>

          {/*Right SIde */}
          <div className="w-right">
                <motion.div
                animate={{rotate: 360}}
                whileInView={{rotate: 90}}
                viewport={{rotate: 90}}
                transition={transition} 
                className="w-mainCircle">
                    <div className="w-secCircle">
                        <img src={Upwork} alt="" />
                    </div>
                    <div className="w-secCircle">
                        <img src={Fiverr} alt="" />
                    </div>
                    <div className="w-secCircle">
                        <img src={Shopify} alt="" />
                    </div>
                    <div className="w-secCircle">
                        <img src={Amazon} alt="" />
                    </div>
                    <div className="w-secCircle">
                        <img src={Facebook} alt="" />
                    </div>
                </motion.div>
                {/*Background Circles */}
                <div className="w-backCircle blueCircle"></div>
                <div className="w-backCircle yellowCircle"></div>
              </div>
      </div>
  )
}

export default Portfolio